import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { PatchMediaPlaylistRefDto } from '@/types/dtos/media/request/patch-media-playlist-ref.dto.ts';
import type { MediaPlaylistDto } from '@/types/dtos/media/media-playlist.dto.ts';
import { patchMediaPlaylistInQueryCache } from '@/state/mutations/media/patch-media-playlist-cache.ts';
import { invalidateSimulationCueSheet } from '@/state/queries/player/use-get-simulation-cue-sheet';

type UpdateAdvanceModeVariables = PatchMediaPlaylistRefDto & {
  playlistId: string;
  usageId: string;
};

export const useUpdateMediaPlaylistRefAdvanceModeMutation = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ playlistId, usageId, ...body }: UpdateAdvanceModeVariables) => {
      const token = await getToken();
      return patchMediaPlaylistRefAdvanceMode(playlistId, usageId, body, token ?? '');
    },
    onSuccess: (updatedPlaylist) => {
      patchMediaPlaylistInQueryCache(queryClient, updatedPlaylist);
      void invalidateSimulationCueSheet(queryClient);
    },
  });
};

const patchMediaPlaylistRefAdvanceMode = async (
  playlistId: string,
  usageId: string,
  body: PatchMediaPlaylistRefDto,
  token: string,
): Promise<MediaPlaylistDto> => {
  const url = `${import.meta.env.VITE_API_URL}/media-playlists/${playlistId}/refs/${usageId}`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body, token });
};
